import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { AttemptModel } from 'Pages/survey'

type AttemptState = {
	data: ResponseCatalog<AttemptModel>
	needSave?: boolean
}

const initialState: AttemptState = {
	data: new ResponseCatalog<AttemptModel>(),
	needSave: undefined,
}

export namespace AttemptNS {
	export type GetAll = PayloadAction<{
		survey_id?: number
		user_id?: number
		callback?: Callback
	}>
	export type GetOne = PayloadAction<{
		id: number
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<AttemptModel>>
	export type CreateOne = PayloadAction<{
		survey_id: number
		callback?: Callback
	}>
	export type UpdateOne = PayloadAction<{
		attempt_id: number
		callback?: Callback
	}>
	export type DeleteOne = PayloadAction<{
		id: number
		callback?: Callback
	}>
	export type ClearOne = PayloadAction
	export type NeedSave = PayloadAction<boolean>
}

export const attemptSlice = createSlice({
	name: 'attempt',
	initialState,
	reducers: {
		getAll: (state, action: AttemptNS.GetAll) => {},
		getOne: (state, action: AttemptNS.GetOne) => {},
		setAll: (state, action: AttemptNS.SetAll) => {
			state.data = action.payload
		},
		createOne: (state, action: AttemptNS.CreateOne) => {},
		updateOne: (state, action: AttemptNS.UpdateOne) => {},
		deleteOne: (state, action: AttemptNS.DeleteOne) => {},
		needSave: (state, action: AttemptNS.NeedSave) => {
			state.needSave = action.payload
		},
		clearOne: (state, action: AttemptNS.ClearOne) => {
			state.data = new ResponseCatalog<AttemptModel>()
		},
	},
})
